import React, { useEffect, useState } from "react"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import {StyledDatePicker} from "./Input.styled"

const DatePickerSelectV2 = ({ label, onChange, size = "md", value }) => {
    const [date, setDate] = useState(dayjs())

    useEffect(() => {
        if (value && dayjs(value).isValid()) setDate(dayjs(value))
        else setDate(dayjs())
    }, [value])

    const changeDate = (value) => {
        setDate(value)
        onChange(value)
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label || "Data"}
                value={date}
                format="DD/MM/YYYY"
                onChange={changeDate}
                slots={{ textField: StyledDatePicker }}
                slotProps={{
                    textField: {
                        variant: "filled",
                        fullWidth: true,
                        pickerSize: size,
                    },
                }}
            />
        </LocalizationProvider>
    )
}

DatePickerSelectV2.propTypes = {
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    size: PropTypes.oneOf(["sm", "md", "xl"]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
}

export default DatePickerSelectV2
